import { render, staticRenderFns } from "./ConfirmChangeContractType.vue?vue&type=template&id=10a898b6&scoped=true"
import script from "./ConfirmChangeContractType.vue?vue&type=script&lang=js"
export * from "./ConfirmChangeContractType.vue?vue&type=script&lang=js"
import style0 from "./ConfirmChangeContractType.vue?vue&type=style&index=0&id=10a898b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a898b6",
  null
  
)

export default component.exports